var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9277 7.43254C13.1286 7.43254 6.75676 13.8175 6.75676 21.755C6.75676 29.6925 13.1286 36.0774 20.9277 36.0774C24.1964 36.0774 27.2007 34.9629 29.6002 33.083C30.2242 32.5941 30.8072 32.0535 31.3427 31.4673C31.9556 30.7963 32.813 30.4006 33.7212 30.3694C34.6295 30.3383 35.5119 30.6744 36.1694 31.3017L48.954 43.502C50.3038 44.7901 50.3538 46.9286 49.0657 48.2784C47.7776 49.6282 45.6391 49.6783 44.2893 48.3901L33.7976 38.378C33.7875 38.386 33.7773 38.3939 33.7672 38.4018C30.225 41.177 25.765 42.8341 20.9277 42.8341C9.34233 42.8341 0 33.3692 0 21.755C0 10.1407 9.34233 0.675781 20.9277 0.675781C32.513 0.675781 41.8554 10.1407 41.8554 21.755C41.8554 22.9072 41.7633 24.0401 41.5855 25.1462C41.2893 26.9883 39.5558 28.2416 37.7137 27.9455C35.8715 27.6493 34.6182 25.9159 34.9144 24.0737C35.0354 23.321 35.0986 22.5466 35.0986 21.755C35.0986 13.8175 28.7268 7.43254 20.9277 7.43254Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic_search.e83195c2d80592249c40921ae45f674f.svg";
export { ForwardRef as ReactComponent };